import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const UserImageDiv = styled.div`
  background-color: ${colors.grey2};
  height: ${(props) => props.height};
  width: ${(props) => props.height};
  min-height: ${(props) => props.height};
  min-width: ${(props) => props.height};
  border-radius: ${(props) => (props.circle ? '50%' : '0')};
  color: ${colors.white};
  font-size: ${(props) => props.size};
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${(props) => props.margin || '0px 10px 0px 0px'};
`;

const Name = styled.div`
  color: ${colors.grey1};
  font-weight: 500;
  font-size: 1.4rem;
`;

const Email = styled.div`
  color: ${colors.grey2};
  font-size: 1.2rem;
`;

const Details = styled.div``;

export default function UserImage({
  imageUrl,
  height = '45px',
  size = '1.8rem',
  firstName,
  lastName,
  phoneNumber,
  margin,
  invert,
  circle = true,
}) {
  if (!imageUrl) {
    let userInitials = '?';

    if (firstName && lastName) {
      userInitials = `${firstName.split('')[0]}${lastName.split('')[0]}`;
    }
    const name = `${firstName} ${lastName}`;

    return (
      <Container>
        <UserImageDiv
          height={height}
          margin={margin}
          invert={invert}
          size={size}
          circle={circle}
        >
          {userInitials}
        </UserImageDiv>
        <Details>
          {firstName && lastName
          && (
          <Name>
            {name}
          </Name>
          )}
          <Email>
            {phoneNumber}
          </Email>
        </Details>
      </Container>
    );
  }
}
